<template>
    <div class="of-content1-social-media">
        <div class="sm-main-svg">
            <img :src="socialMedia.mainSvg" alt="" srcset="">
        </div>
        <div class="sm-content">
            <h3 class="sm-content-title" v-html="socialMedia.title" ></h3>
            <p class="sm-content-text" v-html="socialMedia.text" ></p>
            <div class="sm-content-icons">
                <div class="svg-container selectors">
                    <img 
                        ref="facebook"
                        class="social selected"
                        @click="handleClickSocial('facebook', $event)"
                        :src="socialMedia.socialMediaSvg.facebook"
                    />
                    <img 
                        ref="instagram"
                        class="social"
                        @click="handleClickSocial('instagram', $event)"
                        :src="socialMedia.socialMediaSvg.instagram"
                    />
                    <img 
                        ref="twitter"
                        class="social"
                        @click="handleClickSocial('twitter', $event)"
                        :src="socialMedia.socialMediaSvg.twitter"
                    />
                    <img 
                        ref="youtube"
                        class="social"
                        @click="handleClickSocial('youtube', $event)"
                        :src="socialMedia.socialMediaSvg.youtube"
                    />
                </div>
            </div>
            <ul>
                <li v-for="(social, i) in currentSocial" :key="i">
                    <a 
                        class="a__item"
                        v-html="social['title']"
                        :title="`${social['title']} - ${social['text']}`"
                        :href="social['link']"
                        target="_blank"
                        :data-ba-i="getBaIntelligenceTagName(social)"
                    ></a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'social-media',
        props: ['view'],
        data(){
            return {
                currentSocial: [], /* variavel apenas interna */
                socialNetworkName: 'facebook', /* variavel apenas interna */
                socialNetworkColor: '#1877f2', /* variavel apenas interna */


                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-social-media-card.svg',
                title: 'Join Community',
                text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                'url_socials': { /* nao colocar no translation na view php, vem de outro lugar */
                    facebook: {
                        title: 'titulo facebook',
                        text: 'texto facebook',
                        link: 'https://www.facebook.com/'
                    },
                    instagram: {
                        title: 'titulo instagram',
                        text: 'texto instagram',
                        link: 'https://www.instagram.com/'
                    },
                    twitter: {
                        title: 'titulo twitter',
                        text: 'texto twitter',
                        link: 'https://twitter.com/'
                    },
                    youtube: {
                        title: 'titulo youtube',
                        text: 'texto youtube',
                        link: 'https://www.youtube.com/'
                    }                     
                },
                socialMediaSvg: {
                    facebook: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-facebook.svg',
                    instagram: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-instagram.svg',
                    twitter: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-twitter.svg',
                    youtube: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-youtube.svg'                 
                }
            }
        },
        methods: {
            pageRedirect: function (link){
                window.open(link, '_blank')
            },
            handleClickSocial(type, event) {
                let social = document.querySelectorAll('.social');
                Array.from(social).map(el => el.classList.remove('selected'));
                event.target.classList.add('selected');
                this.currentSocial = this.socialMedia.url_socials[type];
                this.socialNetworkName = type;
                if(type == 'instagram') this.socialNetworkColor = '#b836a9';
                if(type == 'youtube') this.socialNetworkColor   = '#ff0000';
                if(type == 'twitter') this.socialNetworkColor   = '#1b97f0';
                if(type == 'facebook') this.socialNetworkColor  = '#1877f2';
            },
            getBaIntelligenceTagName(social){
                let tag = `fc-social-${social.type}-`
                switch(social.type){
                    case 'facebook':
                        tag += social.link.search('/group') != -1 ? `community-${social.id}` : `official-${social.id}`
                        break;
                    case 'instagram':
                    case 'youtube':
                    case 'twitter':
                        tag += `official-${social.id}`
                        break;
                }
                return tag
            }
        },
        computed: {
            socialMedia: function () {
                return (this.view !== undefined && this.view !== null) ? this.view : this.$data
            }
        },
        created(){

        },
        mounted() {
            this.currentSocial = this.socialMedia.url_socials['facebook'];
            Object.keys(this.socialMedia.url_socials).map((el) =>{
                if(this.socialMedia.url_socials[el].length == 0) {
                    if(el == 'instagram') this.$refs.instagram.style.display = 'none';
                    if(el == 'youtube') this.$refs.youtube.style.display = 'none';
                    if(el == 'twitter') this.$refs.twitter.style.display = 'none';
                    if(el == 'facebook') this.$refs.facebook.style.display = 'none';
                }
            });
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../../scss/office";
    .of-content1-social-media{
        font: inherit;
        border-radius: 4px;
        background-color: $of-color3;
        box-sizing: border-box;
        
        display: grid;
        grid-template-columns: repeat(10, 1fr);
        grid-template-rows: auto;
        justify-items: stretch;
        align-items: stretch;
        justify-content: start;
        align-content: stretch;


        .sm-main-svg{
            grid-column: span 4;
            position: relative;
            img{
                position: absolute;
                width: 100%;
                height: auto;
                max-height: 100%;
                left: -11.05%;
                bottom: -1.2%;
            }
        }
        ul {
            li {
                margin-bottom: .3rem;
                .a__item {
                    text-transform: capitalize;
                    font-size: 1.1rem;
                    position: relative;
                    // text-decoration: underline;
                    &::after {
                        content: '•';
                        position: absolute;
                        left: -10px;
                        top: -2px;
                    }
                }
            }
        }
        .sm-content{
            font: inherit;
            grid-column: span 6;
            padding: 1.2em 6.4em 1.2em 0; /*12px 64px 12px 0 */
            text-align: left;
            h3,
            .sm-content-title {
                font: inherit;
                font-family: $of-font1;
                font-size: 3em; /* 30px */
                font-weight: 700;
                color: $of-color1;
                margin: 0 0 0.266666667em 0;/*8px */
                line-height: 1.2;
            }
            p,
            .sm-content-text{
                font: inherit;
                font-size: 1.4em; /* 14px */
                line-height: 1.2;
                margin: 0 0 1.571428571em 0; /*22px */
                color: $of-color2;
            }
            .sm-content-icons{
                font: inherit;
                margin: 0 0 3.2em 0; /*32px */
                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -khtml-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                .svg-container{
                    height: 100%;
                    width: auto;
                    display: flex;
                    img {
                        height: 30px;
                        margin: 0 .45rem 0 0;
                        opacity: .67;
                        transition: .3s all ease;
                        &.selected,
                        &:hover{
                            opacity: 1;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }


    @media (max-width: 768px) { /* smartphones e tablets */
        .of-content1-social-media{
            grid-template-columns: 1fr;
            grid-template-rows: repeat(2, auto);
            align-items: start;
            justify-items: center;

            .sm-main-svg{
                width: 90%;
                img{
                    position: relative;
                    bottom: auto;
                    left: auto;
                }
            }
            .sm-content{
                width: 90%;
                padding: 1.75% 0;
                h3,
                .sm-content-title {
                    font-size: 3.6em; /* 36px */
                }
                p,
                .sm-content-text{
                    font-size: 1.68em; /* 16.8px */
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-1/social-media.vue